import PhotosStep from './PhotosStep';

export default PhotosStep;
